import {ChangeDetectionStrategy, Component, Input, OnDestroy} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SubstituteScope} from '../../../reducers/substitute/substitute.reducer';
import {Substitute} from '../../../shared/models/substitute.model';
import {ModalService} from '../../../shared/services/modal-service.service';
import {SubstituteService} from '../../../shared/services/substitute.service';
import {UtilsService} from '../../../shared/services/utils.service';
import {AddSubstituteComponent} from '../../modals/add-substitute/add-substitute.component';
import {AddSubstituteData, AddSubstituteResponse} from '../../modals/add-substitute/add-substitute.types';
import {EditSubstituteComponent} from '../../modals/edit-substitute/edit-substitute.component';
import {EditSubstituteData, EditSubstituteResponse} from '../../modals/edit-substitute/edit-substitute.types';

@Component({
  selector: 'app-substitute-list',
  templateUrl: './substitute-list.component.html',
  styleUrls: ['./substitute-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubstituteListComponent implements OnDestroy {
  private ngUnsubscribe = new Subject<void>();
  displayedColumns = ['user', 'substituteUser', 'requestor', 'startDate', 'endDate', 'actions'];

  @Input() scope: SubstituteScope = 'my';
  @Input() testId = 'substitutes';
  @Input() substitutes: Substitute[] = [];

  constructor(
    private modalService: ModalService,
    private substituteService: SubstituteService,
    private translatePipe: TranslatePipe,
    public utilsService: UtilsService
  ) {}

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  addSubstitute(): void {
    this.modalService
      .openModal<AddSubstituteComponent, AddSubstituteData, AddSubstituteResponse>(
        AddSubstituteComponent,
        {
          scope: this.scope
        },
        undefined,
        false
      )
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(dialogResponse => this.handleAfterClosed(dialogResponse));
  }

  private handleAfterClosed(value: AddSubstituteResponse) {
    if (value) {
      this.substituteService.reload();
    }
  }

  removeSubstitute(substitute: Substitute): void {
    this.modalService
      .openConfirmationModal(this.translatePipe.transform('module.substitute.substitute.remove-substitute'), '')
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(confirm => {
        if (confirm) {
          this.substituteService.remove(this.scope, substitute?.user?.userName, substitute?.substituteUser?.userName);
        }
      });
  }

  editSubstitute(substitute: Substitute): void {
    this.modalService
      .openModal<EditSubstituteComponent, EditSubstituteData, EditSubstituteResponse>(
        EditSubstituteComponent,
        {
          substitute,
          scope: this.scope
        },
        undefined,
        false
      )
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(dialogResponse => this.handleAfterClosed(dialogResponse));
  }
}
